import { RoutesOrderMen } from '@/enums/signup'
import { getCookieDomain } from '@/utils/cookie'
import { serializeParameters } from '@/utils/general'

export default function ({ store: { state: { signup, app: appState } }, redirect, route, app }) {
  const { form: { size, prospectId, design, paymentId }, addressConfirmed } = signup
  const { country, locale } = appState

  const i18Params = `/${locale}-${country}`

  const path = route.name.replace('lang-', '')
  const pathIndex = RoutesOrderMen.findIndex(routeName => routeName === path)

  const queryParamsString = serializeParameters(route.query)

  const isPendingPage = pathIndex === 8
  const isSuccessPage = pathIndex === 10

  if (isPendingPage) {
    app.$cookies.remove('apollo-expires', {
      path: '/',
      domain: getCookieDomain()
    })
    app.$cookies.remove('apollo-token', {
      path: '/',
      domain: getCookieDomain()
    })
  }

  const isPaymentPendingOrSuccessPage = isPendingPage || isSuccessPage

  if (!isPaymentPendingOrSuccessPage && pathIndex !== -1) {
    if (paymentId && pathIndex < 6) {
      return redirect(`${i18Params}/men/signup/create-account/verification-payment?${queryParamsString}`)
    }

    if (!size.reference && pathIndex > 1) {
      return redirect(`${i18Params}/men/signup?${queryParamsString}`)
    }

    if (!design.slug && pathIndex > 3) {
      return redirect(`${i18Params}/men/signup/boxershort?${queryParamsString}`)
    }

    if (!prospectId && pathIndex > 4) {
      return redirect(`${i18Params}/men/signup/create-account?${queryParamsString}`)
    }

    if (!addressConfirmed && pathIndex > 5) {
      return redirect(`${i18Params}/men/signup/create-account/address?${queryParamsString}`)
    }
  }
}
